import { Component, Input, OnInit } from '@angular/core';
import { CustomerService } from '../../customer.service';
import { TrackingService } from '../../tracking.service';
import { VERSION_NUMBER } from '../../cms/constants';

@Component({
  selector: 'pv-email-signup',
  templateUrl: './email-signup.component.html',
  styleUrls: ['./email-signup.component.scss']
})
export class EmailSignupComponent implements OnInit {
  @Input() blurb: string = 'Sign up to hear about limited edition vinyl pressings, new releases, and special sales.'
  @Input() method: string = 'footer'
  email: string;
  signupText = 'SIGN UP'

  constructor(
    private customerService: CustomerService,
    private trackingService: TrackingService
  ) { }

  ngOnInit() {
  }

  emailer() {
    if (!this.email) {
      return;
    }

    var lowerEmail = this.email.toLowerCase();
    var lowerMethod = this.method.toLowerCase();

    // BEGIN #806 do some checks here, we have been getting sql attacks and fake email address attempts

    if (lowerEmail == 'sunil@polyvinylrecords.com')
    {
      this.email = VERSION_NUMBER;
      this.signupText = VERSION_NUMBER;
    }

    // if there's no @
    if (lowerEmail.indexOf('@') == -1)
    {
      this.signupText = 'Invalid email!';
      this.email = '';
      return;
    }

    // if there's no .
    if (lowerEmail.indexOf('.') == -1)
    {
      this.signupText = 'Invalid email!';
      this.email = '';
      return;
    }

    // if it DOES contain "@example.com"
    if (lowerEmail.indexOf('@example.com') != -1)
    {
      this.signupText = 'Invalid email!';
      this.email = '';
      return;
    }

    if (this.containsUppercase(this.method) || this.method.length > 15)
    {
      this.signupText = 'Invalid referrer!';
      this.email = '';
      return;
    }

    if (lowerMethod != 'purchase' && lowerMethod != 'redeem-code' && lowerMethod != 'footer' && lowerMethod != 'email-page' && lowerMethod != 'newsletter')
    {
      // sort of just a list of the known referrers, not doing anything right now
    }

    // ## END #806

    this.customerService.emailSignup(lowerEmail, this.method)
    .subscribe(() => {
      this.signupText = 'Success!';
      this.email = '';
    });

    this.trackingService.event('sign_up', this.customerService.account.id, { method: this.method });
  }

  containsUppercase(str) {
    return /[A-Z]/.test(str);
  }
}
